import { useState, useEffect } from 'react';

// https://usehooks.com/useWindowSize/
const useWindowSize = () => {
  const initialState = { width: undefined, height: undefined };
  const [windowSize, setWindowSize] = useState(initialState);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);

    handleResize(); // Call handler right away so state gets updated with initial window size

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};

export default useWindowSize;
